/* MR.VIK — hero banner slideshow.
   Standalone (not part of mrvik.js) so the hero can run before the rest of the
   page JS parses; it is the first thing on screen.

   Behaviour: crossfade, optional autoplay, arrows, dots and touch swipe.
   Autoplay stops on hover, on any manual interaction, and when the tab is
   hidden — a rotating banner in a background tab is wasted work. */
(function () {
  'use strict';

  function init(root) {
    var slides = root.querySelectorAll('[data-bn-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-bn-dot]');
    var prev = root.querySelector('[data-bn-prev]');
    var next = root.querySelector('[data-bn-next]');
    var i = 0;
    var timer = null;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var every = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('is-on', s === i);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', d === i);
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
    }

    function start() { if (auto && !timer) timer = setInterval(function () { show(i + 1); }, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    // a deliberate tap/click hands control over for good
    function take(n) { auto = false; stop(); show(n); }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); take(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); take(i + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function (e) { e.preventDefault(); take(n); });
      })(d);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    /* touch swipe. The slides are anchors, so a horizontal drag must not fire
       the link — we only treat it as a swipe past a 40px threshold, and let
       anything shorter through as a normal tap. */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
        take(dx < 0 ? i + 1 : i - 1);
      }
    });

    show(0);
    start();
  }

  function boot() {
    var all = document.querySelectorAll('[data-mv-banner]');
    for (var n = 0; n < all.length; n++) init(all[n]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // re-init when the theme editor swaps the section
  document.addEventListener('shopify:section:load', boot);
})();
